import type { MeModel } from "../utils/generated/api.js"
import { useTokenCookie } from "./local/token-cookie"

export type UserModel = MeModel

export const useLogin = defineComposable("login", () => {
	const api = useApi()
	const token = useTokenCookie()

	const userData = ref<UserModel | null>(null)
	const isLogged = ref(false)

	function setUser(input: UserModel) {
		userData.value = input
		isLogged.value = true
	}

	async function whoAmI() {
		if (!token.getCookie()) {
			isLogged.value = false
			userData.value = null
			return
		}

		try {
			const { data } = await api.user.me()
			isLogged.value = true
			userData.value = data
		}
		catch {
			isLogged.value = false
			userData.value = null
		}
	}

	async function login(_username: string, _password: string) {
		isLogged.value = true
	}

	async function logout() {
		isLogged.value = false
		token.clearCookie()
		await navigateTo("/app/login")
		userData.value = null
	}

	return {
		isLogged,
		userData,
		setUser,
		whoAmI,
		login,
		logout,
	}
})
